export default "__VITE_ASSET__BY14AyEg__"